import { db, storage } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_IMAGES_RESTAURANT_USER = 'SET_IMAGES_RESTAURANT_USER';
export const SAVING_RESTAURANT = 'SAVING_RESTAURANT';
export const SAVED_RESTAURANT = 'SAVED_RESTAURANT';

const setImagesRestaurantUser = payload => ({ type: SET_IMAGES_RESTAURANT_USER, payload });
export const setSavingRestaurant = payload => ({ type: SAVING_RESTAURANT, payload });
export const setSavedRestaurant = payload => ({ type: SAVED_RESTAURANT, payload });

export const setImagesDataToRestaurant = payload => {
    return dispatch => {
        var isSavingRestaurant = true;
        dispatch(setSavingRestaurant(isSavingRestaurant));
        const { id, imageProfile, imagesSlider } = payload;
        if(id) {
            const imageNameProfile = `restaurants/${id}/logo`;
            const imageNameSlider = `restaurants/${id}/slider`;
            const media = [];
            var promisesSaveImagesStorage = [];
            var logo = "";
            if(imageProfile) {
                if(imageProfile.originFileObj) {
                    var storageLogo = storage.ref().child(imageNameProfile).put(imageProfile.originFileObj);
                    promisesSaveImagesStorage.push(storageLogo);
                }
                logo = imageNameProfile;
            } else {
                //TODO remove images if exists
            }
            if(imagesSlider) {
                imagesSlider.forEach((image, index) => {
                    if(index < 10) {
                        if(image.originFileObj) {
                            var storageSlider = storage.ref().child(`${imageNameSlider}0${index + 1}`).put(image.originFileObj);
                            promisesSaveImagesStorage.push(storageSlider);
                        }
                        media.push({ url: `${imageNameSlider}0${index + 1}`, order: index + 1 });
                    }
                });
            } else {
                //TODO remove images if exists
            }
            return Promise.all(promisesSaveImagesStorage)
            .then(() => {
                return db.ref(`${Constants.RESTAURANTS}/${id}`).update({
                    logo: logo,
                    media: media,
                })
                .then(() => {
                    dispatch(setImagesRestaurantUser({ payload, logo: imageProfile ? imageNameProfile : "", media }));
                    dispatch(setSavingRestaurant(isSavingRestaurant = false));
                    var isSavedRestaurant = true;
                    dispatch(setSavedRestaurant(isSavedRestaurant));
                })
                .catch(err => {
                    console.log("not found save data");
                    dispatch(setSavingRestaurant(isSavingRestaurant = false));
                });
            })
            .catch(err => {
                console.log("not found save data");
                dispatch(setSavingRestaurant(isSavingRestaurant = false));
            });
        } else {
            console.log("id undefined: ");
            dispatch(setSavingRestaurant(isSavingRestaurant = false));
        }
    };
};